export class EventEmitter {

  constructor() {
    this._events = {};
  }

  on(eventName, callback, context) {
    if (!this._events.hasOwnProperty(eventName)) {
      this._events[eventName] = [];
    }

    this._events[eventName] = this._events[eventName].concat([{ callback, context }]);
  }

  off(eventName, callback, context) {
    if (!callback) {
      this._events[eventName] = [];
    }

    this._events[eventName] = this._events[eventName].filter((subscription) => {
      return subscription.callback !== callback || subscription.context !== context;
    });
  }

  emit(eventName, data) {
    if (!Array.isArray(this._events[eventName])) {
      return;
    }

    this._events[eventName].forEach((subscription) => {
      subscription.callback.apply(subscription.context, [data]);
    });
  }
}
